// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManagementSystem_wrapper__3cDXK"};